<stages-card #card [contentCollapsible]="contentCollapsible">
<!--	[toolbarId]="toolbarId" [toolbarItems]="toolbarItems" [menuId]="menuId" [menuItems]="menuItems" [menuNoCollapse]="menuNoCollapse">-->
	<h5 [translate]="title"></h5>
	<ng-container stagesSlot="content"></ng-container>
	<stages-add-sequence *ngIf="sequenceOptions && card.expanded" [sequences]="sequenceOptions"></stages-add-sequence>
</stages-card>
